import Declaration from '../declararion/Declaration';
import StepperComponent from '../profile/StepperComponent';
import Manual from '../manual/Manual';

const pageList = [
  //   {
  //     name: 'Головна',
  //     path: '/',
  //     component: Home
  //   },
  {
    name: 'Заява',
    path: '/profile-page',
    component: Declaration
  },
  {
    name: 'Юзерс',
    path: '/profile-page/profile',
    component: StepperComponent
  },
  {
    name: 'Create',
    path: '/profile-page/:id',
    component: StepperComponent
  },
  {
    name: 'Create',
    path: '/profile-page/add',
    component: StepperComponent
  },
  {
    name: 'Edit',
    path: '/profile-page/edit',
    component: StepperComponent
  },
  {
    name: 'Manual',
    path: '/profile-page/manual',
    component: Manual
  }
];

export default pageList;
